import { useDispatch, useSelector } from 'react-redux';
import { apiClient } from '../../utils/axios';
import { showSnackbar } from '../../api/snackbarSlice';

export const usePdfActions = () => {
  const dispatch = useDispatch();

  const downloadPdf = async ({ url, fileName }) => {
    dispatch(showSnackbar({ message: 'Downloading document...', severity: 'info' }));

    try {
      const response = await apiClient.get(url, {
        responseType: 'blob', // important for binary data
        headers: {
          Accept: 'application/pdf',
        },
      });

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const downloadUrl = window.URL.createObjectURL(blob);

      const xFilename = response.headers?.['x-suggested-filename'];
      const finalFileName = xFilename ?? fileName;

      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', finalFileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(downloadUrl);
      dispatch(showSnackbar({ message: 'Document downloaded successfully!', severity: 'success' }));
    } catch (error) {
      dispatch(showSnackbar({ message: 'Failed to download document', severity: 'error' }));
      console.error(error);
    }
  };

  const handlePrintPdf = async ({ url, fileName }) => {
    try {
      const response = await apiClient.get(url, {
        responseType: 'blob',
        headers: { Accept: 'application/pdf' },
      });

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const xFilename = response.headers?.['x-suggested-filename'];
      const finalFileName = xFilename ?? fileName ?? 'document.pdf';
      const printWindow = window.open(URL.createObjectURL(blob), '_blank');
      if (!printWindow) {
        dispatch(showSnackbar({ message: 'Unable to open print window', severity: 'error' }));
        return;
      }

      printWindow.onload = () => {
        printWindow.document.title = finalFileName;
        printWindow.focus();
        printWindow.print();
      };
      dispatch(showSnackbar({ message: 'Document printed successfully!', severity: 'success' }));
      return true;
    } catch (error) {
      dispatch(showSnackbar({ message: 'Failed to print document', severity: 'error' }));
      console.error(error);
      return false;
    }
  };

  return { downloadPdf, handlePrintPdf };
};
